import { atom } from "recoil"

export const listMatchingOfferDraftRequestIdState = atom({
  key: "atoms/matching/listMatchingOfferDraftRequestIdState",
  default: 0,
})
